import React, { useEffect, useState } from "react";
import {
  deadlinesScopes,
  deadlinesRecurringScopes
} from "../../../constants/scadenze";
import { Select } from "antd";
import { FormattedMessage } from "react-intl";
const Option = Select.Option;

const  Scope = ({ frequencyType, isReconciliationForm, isSave, requestBody, setRequestBody}) => {
  const [scopeError, setScopeError] = useState(false);

  const scopes = [];
  let arrayFrequencyBased;

  if (frequencyType === "recurring") {
    arrayFrequencyBased=deadlinesRecurringScopes;
  } else {
    arrayFrequencyBased=deadlinesScopes;
  }

  for (const [key, value] of Object.entries(arrayFrequencyBased)) {      
    scopes.push(<Option value={key} key={key}>{value}</Option>);
  }

  useEffect(() => {   
    if (!isSave) setScopeError(false); 
    else setScopeError(!requestBody.scope);
  }, [isSave]);

  return (
    <div data-testid="container" className={scopeError ? "errorOccurs" : ""}>
      <div data-testid="labelDialogContent" className="labelDialogContent">        
        <FormattedMessage id={isReconciliationForm ? "reconciliation.deadlines.scope" : "deadlines.pages.create.deadlineType"}/>         
      </div>
      <div className="customSelect largeSelect">
        <Select
          data-testid="selectScope"
          dropdownClassName="modalOverlay"
          getPopupContainer={trigger => trigger.parentNode}
          size="large"
          value={requestBody.scope}
          placeholder="Scegli l'ambito della scadenza"
          onChange={(value) => {
            setScopeError(false);
            let defaultPaymentTypeValue = "";
            let defaultPaymentStatusValue = "";
            switch (value){
            case "credit": 
              defaultPaymentTypeValue = "item_collect";
              defaultPaymentStatusValue = "due";
              break;
            case "debt": 
              defaultPaymentTypeValue = "item_pays";
              defaultPaymentStatusValue = "due";
              break;
            default: 
              defaultPaymentTypeValue = undefined;
              defaultPaymentStatusValue = "due";
              break;
            }

            setRequestBody({
              ...requestBody,
              counterpart: {
                ...requestBody.counterpart,
                description: value === "fiscal_social_security" ? "Erario" : requestBody.counterpart.description
              },
              type:
                    value === "debt" ? "supplier" : value === "credit" ? "customer" : null,
              scope:  value,
              payment: {
                ...requestBody.payment,
                type: defaultPaymentTypeValue,
                status: defaultPaymentStatusValue
              },
              status: {
                ...requestBody.status,
                confirmed: value === "fiscal_social_security" ? true : requestBody.status.confirmed
              }              
            });              
          }}
        >
          {scopes}
        </Select>
      </div>
    </div>
  );
};

export default Scope;